<template>
<div id="login_az_app">
    <router-view></router-view>
    <div class="footer">
        <div>
            <span>© AquaZor, 2019</span>
        </div>
        <div>
            <span style="right: 0">Техподдержка:
            <a href="mailto:support@aquazor.ru">support@aquazor.ru</a>
            <a href="tel:+74951202269">+7(495) 120-22-69</a>
        </span>
        </div>
    </div>
    <b-modal size="lg" title="" :hide-footer="true" v-model="modalForMobileShow">
        <h3 class="text-center">А с приложением удобнее</h3>
        <div class="app-buttons-block row">
            <div class="col-md-6 text-center app-button">
                <a href="https://itunes.apple.com/ru/app/aquazor/id1455525142">
                    <img src="/static/img/app_store_logo.png" class="to-app-icon">
                </a>
            </div>
            <div class="col-md-6 text-center app-button">
                <a href="https://play.google.com/store/apps/details?id=ru.aquazor.app">
                    <img src="/static/img/google_play.png" class="to-app-icon">
                </a>
            </div>
        </div>
    </b-modal>
</div>
</template>

<script>
import '@/assets/css/main.css'

export default {
    data() {
        return {
            modalForMobileShow: false
        }
    },
    created() {
        var html_elements = document.getElementsByTagName('html');
        for (var i = 0; i < html_elements.length; i++) {
            html_elements[i].className = "main";
        }
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            console.log('mobile')
            if (!localStorage.mobileModalIsShow) {
                this.modalForMobileShow = true
                localStorage.mobileModalIsShow = true
            }
        } else {
            console.log('PC')
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/layouts/LoginLayout.vue